import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISiteTimerModel } from '../models'

export class DeleteTimerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/siteTimerDelete',
      requesterInfo,
    })
  }

  public async timerDelete(req: number): Promise<ISiteTimerModel[]> {
    return await this.postAsync<ISiteTimerModel[]>(req)
  }
}
